import { isNative } from '@bubble-ui/util-platform';
export var offsetRenderStylesLineHeight = lineHeight => {
  if (isNative && lineHeight) {
    var renderingOffset = Math.round(0.2 * lineHeight);
    return {
      marginTop: -renderingOffset,
      marginBottom: -renderingOffset,
      marginLeft: 0,
      marginRight: 0,
      paddingTop: renderingOffset,
      paddingBottom: renderingOffset,
      paddingLeft: 0,
      paddingRight: 0
    };
  }
  return {};
};
//# sourceMappingURL=index.js.map